module.exports = __webpack_public_path__ + "img/import-in-mass-simulation.dd575a34.svg";